import React, { useState } from 'react';
import styled from 'styled-components';
import { BorderedField, Flex } from './Flex';
import { EyeIcon } from '../icons/EyeIcon';
import { EyeInvisibleIcon } from '../icons/EyeInvisibleIcon';


const StyledInput = styled.input.attrs(({ autoFocus }) => ({
    autoFocus: autoFocus
}))`
    height: ${({ height}) => height ? height : "32px"};
    padding: ${({ padding }) => padding};
    width: 100%;
    font-size: 14px;
    line-height: 19px;
    color: #163466;
    text-transform: ${({ uppercase }) => uppercase && 'uppercase'};
    border-radius: ${({ radius }) => radius};
    border: none;

    &[disabled] {
        background: var(--sp-disabled-color);
    }

    &:focus {
        outline: none;
    }
`
const StyledPasswordIcon = styled.span`
    margin-left: 4px;
    cursor: pointer;
    &:active > i {
        transform: translateY(1px);
    }
`
const StyledTextArea = styled.textarea.attrs(({ rows }) => ({
    autoComplete: "off",
    rows: rows
}))`
    resize: none;
    padding: 4px 11px;
    width: 100%;
    font-size: 14px;
    line-height: 19px;
    color: #163466;
    border: none;
    border-radius: 8px;
    &[disabled] {
        background: var(--sp-disabled-color);
    }

    &:focus{
        outline: none;
    }
`;

const Input = React.forwardRef(({ bordered=true, onPressEnter, ...props}, ref) => {

    const onKeyPress = (e) => {
        e.stopPropagation();
        let keyCode = e.code || e.key;
        if (keyCode == 'Enter' && typeof onPressEnter == "function") {
            onPressEnter(e);
        }
    };

    const component = <StyledInput radius={bordered ? "6px" : "8px"} padding={bordered ? "0 11px" : 0} onKeyPress={onKeyPress} {...props} ref={ref} />;

    return(bordered
        ? <BorderedField hasError={props.error}>
            {component}
        </BorderedField>
        : component
    )
});

Input.Password = React.forwardRef(({ bordered=true, ... props }, ref) => {
    const [visible, setVisible] = useState(false);

    const component = <Flex align="center" width="100%">
            <StyledInput type={visible ? "text" : "password"} ref={ref} {...props}/>
            <StyledPasswordIcon onClick={() => setVisible(!visible)} >
                {visible ? <EyeIcon /> : <EyeInvisibleIcon />}
            </StyledPasswordIcon>
        </Flex>

    return(bordered
        ? <BorderedField padding={{ left: "11px", right: "4px" }} hasError={props.error}>
            {component}
        </BorderedField>
        : component
    )
});

Input.TextArea = React.forwardRef(({ bordered=true, rows=3, ... props }, ref) => {

    const component = <StyledTextArea rows={rows} {...props} ref={ref} />;

    return(bordered
        ? <BorderedField hasError={props.error}>
            {component}
        </BorderedField>
        : component
    )
})


export { Input };